<template>
  <div class="wrapper" ref="body" :class="[dishFixed ? 'fixed' : '']">
    <div class="top" ref="top">
      <div class="con">
        <div class="title">为销售赋能的名片SCRM</div>
        <div class="mark">颠覆传统销售模式<br>撬动千亿级市场</div>
        <div class="text">企业销售与客户之间进行商务社交的过程，小名片帮助企业实现品牌传播，产品营销，且对销售过程进行监管，留存客户资源</div>
        <!--转盘部分-->
        <div class="dish" >
          <div class="dish-img">
            <img :src="dishImg" alt="" >
          </div>
          <!--dish-icon-->
          <img src="~../../assets/images/dish-icon.png" alt="" class="dish-icon" ref="dishicon" @click="handleDishClick">
        </div>
        <!--标记-->
        <div class="number">01</div>
      </div>

      <!--渐变颜色带-->
      <div class="lace"></div>
    </div>

    <!--tab区域-->
    <div class="tab" ref="tab">
      <div class="point" slot="tab-point">
        <span style="display:none;" v-for="(item, index) in list" :key="index"></span>
      </div>
      <div class="content" slot="tab-content">
        <div v-for="(item,index) in list" :key="index" style="height: 460px;" ref="items" :id="item.id">
          <index-item  :img="item.img" :title="item.title" :mode="item.mode"
            :text="item.text" @next="itemNext" :index="index" >
          </index-item>
        </div>

      </div>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import IndexItem from './IndexItem'
import img1 from '../../assets/images/01chahua1.png'
import img2 from '../../assets/images/01chahua2.png'
import img3 from '../../assets/images/01chahua3.png'
import img4 from '../../assets/images/01chahua4.png'

import dish1 from '../../assets/images/dish1.png'
import dish2 from '../../assets/images/dish2.png'
import dish3 from '../../assets/images/dish3.png'
import dish4 from '../../assets/images/dish4.png'


import Tab from '../common/tab'
import {getWindowScrollTop } from '../../common/dom'
const area = [
  {
    x: {
      max: 464,
      min: 330
    },
    y: {
      max: 262,
      min: 104
    }
  },
  {
    x: {
      max: 607,
      min: 510
    },
    y: {
      max: 262,
      min: 104
    }
  },
  {
    x: {
      max: 607,
      min: 510
    },
    y: {
      max: 413,
      min: 262
    }
  },
  {
    x: {
      max: 464,
      min: 330
    },
    y: {
      max: 413,
      min: 262
    }
  }
]
export default {
  data() {
    return {
      dishFixed: false,
      list: [
        {
          id: 'index-part-one-one',
          img: img1,
          title: '全面链接  人脉裂变',
          mode: 'left',
          text: [
            '让销售连接微信10亿用户，一键将小程序分享给微信好友、微信群、朋友圈，通过朋友将服务与产品“发出去”，形成快速传播',
            '企业员工只需分享个人名片小程序至微信，销售雷达即可进行商机捕捉'
          ]
        },
        {
          id: 'index-part-one-two',
          img: img2,
          title: '访客轨迹  智能预测',
          mode: 'right',
          text: [
            '客户查看名片、查看企业官网等行为都将被记录，并且实现访客IM既时通讯，智能数据分析挖掘高度意向客户，预测客户成交率，精准营销快速转化',
            '可视化分析系统，实际监控销售行为，帮助企业沉淀客户流量资产'
          ]
        },
        {
          id: 'index-part-one-three',
          img: img3,
          title: '品牌传播  企业展示',
          mode: 'left',
          text: [
            '开启全员社交流量，统一展示公司的企业品牌及产品信息，不仅仅是销售，还有市场、人事等员工都可以开通小名片，为企业增加新的品牌宣传渠道'
          ]
        },
        {
          id: 'index-part-one-four',
          img: img4,
          title: '信息智库  信任背书',
          mode: 'right',
          text: [
            '小名片可展示企业销售员工的联系方式，小官网可展示企业介绍，业务及产品详情',
            '客户存储的不只是名片，自动保存的还有个人和公司信息，方便客户随时查看业务和产品介绍详情'
          ]
        }
      ],
      active: 0,
      dishImg: dish1
    }
  },
  methods:{
    itemNext(index){
      this.$refs.tab.tab((index + 1) % this.list.length)
    },
    checkIndex(x,y){
      let index = area.findIndex(item => {
        if( x >= item.x.min && x <= item.x.max &&  y >= item.y.min && y <= item.y.max) return true
      })
      return index
    },
    getDishImg(index){
      switch(index){
        case 0:
          return dish1
        case 1:
          return dish2
        case 2:
          return dish3
        case 3:
          return dish4
        default:
          return dish1
      }
    },
    handleDishClick(e){
      let index = this.checkIndex(e.layerX,e.layerY)
      this.gotoTarget(this.list[index].id)
    },
    gotoTarget(id){
      if(!id) return
      let top = document.querySelector(`#${id}`).offsetTop
      window.scroll({
        top:top + 500,
        behavior: 'smooth',
      })
      //animate(document.documentElement,'scrollTop',top - 100,600)
    },

  },
  mounted(){
    //this.$bodyTop = this.$refs.body.offsetTop
    //this.$itemTops = this.$refs.items.map(item => item.offsetTop + this.$bodyTop)
    // document.addEventListener('scroll',this.handleScroll)
    this.$refs.dishicon.addEventListener('mousemove', e => {
      let x = e.layerX, y = e.layerY,
        index = this.checkIndex(x,y)
      if(index !== -1){
        this.dishImg = this.getDishImg(index)
      }
    })

  },
  computed: {
  },
  components: {
    IndexItem,
    Tab
  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.wrapper{
  box-sizing: border-box;
  padding-top: 88px;
  position: relative;
  margin: 0 auto;
  max-width: $max-width;
  .top{
    position: relative;
    transition: top 0.7s;
  }
  &.fixed{
    padding-top: 88px + 512px;
    .top{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: 9998;
      background-color:#fff;
      opacity: 0.95;
    }
    .con{
      padding-bottom: 0;
    }
  }
  .con{
    width: 100%;
    max-width: 1200px;
    min-width: $min-width;
    margin: 0 auto;
    position: relative;
    padding-bottom: 128px;
    @media screen and (min-width: $min-width) and (max-width: 1400px){
      box-sizing: border-box;
      padding-left: 60px;
    }
    .title{
      line-height: 1.0;
      font-size: 48px;
      font-weight: bold;
      color: $theme-color;
      margin-bottom: 28px;
    }
    .mark{
      font-size: 36px;
      line-height: 48px;
      color:#2cbb58;
      margin-bottom: 116px;
    }
    .text{
      font-size: 18px;
      line-height: 32px;
      width: 466px;
      position: relative;
      z-index: 1;
    }
    /*转盘部分*/
    .dish{
      position: absolute;
      top: 20px;
      right: 0;
      z-index: 1;
      transition: top .2s;
      @media screen and (min-width: $min-width) and (max-width: 1400px){
        right: 60px;
      }
      .dish-img{
        display: block;
        position: relative;
        &::before{
          content: '';
          display: block;
          width: 100%;
          height: 402px;
          background-color:#fff;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 0;
        }
        img{
          position: relative;
          z-index: 1;
        }

      }
      .dish-icon{
        position: absolute;
        right: -58px;
        top: -60px;
        z-index: 2;
        cursor: pointer;
      }
    }
  }
  .number{
    font-size:180px;
    color:$theme-color;
    font-weight: bold;
    opacity: 0.1;
    position: absolute;
    top: -8px;
    left: -170px;
    line-height: 1.0;
    @media screen and (min-width: $min-width) and (max-width: 1400px){
      left:-110px;
    }
  }
  .lace{
    width: 100%;
    height: 206px;
    background-image: linear-gradient(to right,#fff, #f8f8f8,#fff);
    position:absolute;
    left: 0;
    top: 228px;
  }
}

.fade-enter-active,.fade-leave-active{
  transition: transform .6s;
}
.fade-enter, .fade-leave-to{
  transform: translate(0, 60px);
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexPartOne.vue